<template>
  <!--
    type: select || text-info || text-user || textarea || select-pay || owner-name
    title: "标题"
    required: true || false  是否展示必填标识  *
    tip:'提示信息'
    data: 必应的字典属性
    hide-border：true || false 是否隐藏下划线
    target： 跳转url
    disable:禁止修改
    max:"100" 表单最大限制
    textType:tel || text || email
   -->
  <div>
    <!--立即付款选项展示 -->
    <!-- @click="select"  -->
    <div class="cell-pay" v-if="type =='select-pay'">
      <div class="payway">
        <h3>{{ lang.payway }}</h3>
        <section>
          <ul>
            <template v-for="(item, index) in pay">
              <li v-if="!(($parent.info.topType === 'Star_Buy' || $parent.info.topType === 'Star_Rent' || $parent.mode == 1 || $parent.info.PropertySource == 2 || $store.state.shopType) && item.attr === 'free')" 
              :class="[item.attr == 'trans' ? 'linetrans' : '', {'unclickable':((!store.state.isAllow && !renewalType) && item.attr === 'free')}]" :key="index" @click="selectWarp(item)">
                <div v-if="item.attr === 'free'" class="disFlex">
                  <img :src="item.img" alt="" style="width: 24px; height: 24px" />
                  <div class="freeBox" style="margin-left: 12px">
                    <div class="ali-text">
                      <span class="freeTitle" :class="{'freeOpacity': !store.state.isAllow && !renewalType}">
                        <span class="freeTitle">{{ lang.free }}</span>&nbsp;&nbsp;
                        <span class="freeMax" v-if="!store.state.isAllow">{{ lang.freeMax }}</span>
                        <span v-else class="freeMax">{{ lang.freeNumber }}</span>
                        <img class="enable-click" v-if="store.state.isAllow" style="width: 18px; height: 18px; margin-left: 4px" src="../../assets/tip-icon@2x.png" alt="" @click.stop="tipsEven('free')" />
                      </span>
                    </div>
                    <div v-if="(buyList && buyList.length > 0) || rentList && rentList.length > 0"class="ali-tips" :class="{'freeOpacity': !store.state.isAllow && !renewalType}" style="margin-top: 8px">({{ lang.effectiveProperties }}
                      <span class="ali-tips-buy">{{ buyList && buyList.length > 0 ? lang.saleTitle + ':' : '' }}</span>
                      <template v-if="buyList && buyList.length > 0">
                        <span v-for="(item, index) in buyList" :key="index + 'buy'">
                          <span class="ali-tips">{{ item.propertyID }}</span><span v-if="index < buyList.length - 1">,</span>
                        </span>
                      </template>&nbsp;<span class="ali-tips-rent">{{ rentList && rentList.length > 0 ? lang.rentTitle + ':' : '' }}</span>
                      <template v-if="rentList && rentList.length > 0">
                        <span v-for="(item, index) in rentList" :key="index + 'rent'">
                          <span class="ali-tips">{{ item.propertyID }}</span><span v-if="index < rentList.length - 1">,</span>
                        </span>
                      </template>)
                    </div>
                  </div>
                </div>
                <div v-else-if="item.attr === 'alipay'" class="disFlex">
                  <img :src="item.img" alt="" style="width: 22px; height: 22px" />
                  <div style="margin-left: 12px">
                    <div class="ali-text">AlipayHK</div>
                    <div class="ali-tips" style="margin-top: 8px">({{ lang.alipayText }}）</div>
                  </div>
                </div>
                <div v-else-if="item.attr === 'wepay'" class="disFlex">
                  <img :src="item.img" alt="" style="width: 22px; height: 22px" />
                  <div style="margin-left: 12px">
                    <div class="ali-text">WeChat Pay HK</div>
                    <div class="ali-tips" style="margin-top: 8px">({{ lang.wePayText }})</div>
                  </div>
                </div>
                <div v-else class="disFlex">
                  <img :src="item.img" alt="" :class="item.attr == 'paypal' ? 'paypal-img' : item.attr == 'trans' ? 'trans-image' : item.attr == 'coin' ? 'icon-image' : 'paypal-image'" />
                  <div :class="item.attr == 'paypal' ? 'paypal-text' : item.attr == 'coin' ? 'coin-text' : item.attr == 'paydollar' ? 'cd-text' : item.attr == 'trans' ? 'cd-text' : ''">
                    <div>{{ item.text }}</div>
                    <div class="downMoney" v-if="item.attr == 'trans'" style="margin-top: 8px">{{ lang.transferFake }}</div>
                  </div>
                  <!-- <svg class="icon icon_ver" aria-hidden="true">
                    <use :xlink:href="item.svg" />
                  </svg> -->
                </div>
                <van-radio class="paycol" checked-color="#ee0a24" :name="item.attr" v-model="store.state.payMent" :disabled="(!store.state.isAllow && !renewalType) && item.attr === 'free'"></van-radio>
              </li>
            </template>
          </ul>
        </section>
      </div>
      <!-- <div class="pay-content">
        <h3>{{ lang.payway }}</h3>
        <div v-if="selects.warpData == 'paypal'" class="paypal">
          <img src="../../assets/pay01.png" alt="" />
          <p>({{ lang.visa }})</p>
        </div>
        <div v-if="selects.warpData == 'coin'" class="coin">
          <img src="../../assets/gold.png" height="24px" alt="" />
          <span>{{ lang.Coin }}</span>
        </div>
        <div v-if="selects.warpData == 'trans'" class="trans">
          {{ lang.transfer }}
        </div>
        <van-icon name="arrow" />
      </div> -->
    </div>

    <div :class="['cell', { paddingTop0: attr == 'ToiletNumber' }]" v-else>
      <button v-if="attr == 'titleCN'" class="words" @click="keywords()">{{ lang.selectWords }}</button>
      <button v-if="attr == 'introduceCN'" class="words" @click="introducewords()">{{ lang.selectWords }}</button>
      <button v-if="attr == 'servicesCN'" class="words" @click="facilitiesAndServicesWords()">{{ lang.selectWords }}</button>
      <div :class="['cell-head', { topBorder: attr == 'ToiletNumber' }, { displayFlex: attr == 'unitFloor' }, { paddingTop15: attr == 'ToiletNumber' }]">
        <span class="required" v-if="required">*</span>
        <div v-if="type == 'vid-show'" class="vidDiv" @click="select">
          <h3 v-text="title"></h3>
          <!-- video -->
          <div :class="['vid-conetnt', { noborder: hideBorder }, { fcolor: videoText != this.videoText }]" v-if="type === 'vid-show'">
            <div v-if="store.state.videos.length && store.state.videos[0].videoPath">
              <span class="vidText" v-text="store.state.videos[0].videoPath"></span>
            </div>
            <span v-else v-text="videoText" class="vidText"></span>
          </div>
        </div>
        <div v-else-if="type !== 'vid-show' && type !== 'tags' && type !== 'platimg' && attr == 'estateAddress'" class="estateAddress-box">
          <h3 v-text="title"></h3>
          <van-icon name="info-o" style="margin-left: 7px;" v-show="this.$parent.info.estateID == 0" @click="estateAddressTips" />
        </div>
        <div v-else-if="type !== 'vid-show' && type !== 'tags' && type !== 'platimg' && attr == 'unitFloor'" class="estateAddress-box">
          <h3 v-text="title"></h3>
          <van-icon v-show="this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0" name="info-o" style="margin-left: 7px;" @click="unitFloorTips" />
        </div>
        <h3 v-else-if="type !== 'vid-show' && type !== 'tags' && type !== 'platimg'" v-text="title"></h3>
        <h3 v-text="titleBeh" style="padding-left:10px"></h3>
      </div>
      <!-- <div class="cell-tip" v-if="attr == 'isHideCompanyInfo'">{{ lang.isHideCompanyInfoTip }}</div> -->
      <p class="cell-tip" v-show="tip">{{ tip }}</p>
      <!--  select 选择 -->
      <div
        :class="[
          'cell-conetnt',
          { noborder: hideBorder },
          { disableText: disabled },
          { fcolor: selectText != this.lang.pleSelect && attr != 'unitFloor' && attr != 'RoomNumber' && attr != 'ToiletNumber' },
        ]"
        v-if="type === 'select'"
        @click="select"
      >
        <div v-if="attr == 'images' && store.state.images.length">
          <img :src="item.imagePath | imgResize('list')" width="64px" height="64px" style="border-radius: 4px;" v-for="(item, index) in store.state.images.slice(0, 3)" :key="index" />
        </div>
        <span
          v-text="store.state.phaseText ? store.state.phaseText : lang.pleSelect"
          v-else-if="attr == 'phaseWithCulture'"
          :class="{ disText: true, fcolor: store.state.phaseText && store.state.phaseText != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.buildText ? store.state.buildText : lang.pleSelect"
          v-else-if="attr == 'buildingNameWithCulture'"
          :class="{ disText: true, fcolor: store.state.buildText && store.state.buildText != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.floorText ? store.state.floorText : lang.pleSelect"
          v-else-if="attr == 'buildFloor'"
          :class="{ disText: true, fcolor: store.state.floorText && store.state.floorText != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.roomNoWithCulture ? store.state.roomNoWithCulture : lang.pleSelect"
          v-else-if="attr == 'roomNoWithCulture'"
          :class="{ disText: true, fcolor: store.state.roomNoWithCulture && store.state.roomNoWithCulture != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.roomNumberText ? store.state.roomNumberText : lang.pleSelect"
          v-else-if="attr == 'RoomNumber'"
          :class="{ disText: true, fcolor: store.state.roomNumberText && store.state.roomNumberText != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.toiletNumberText ? store.state.toiletNumberText : lang.pleSelect"
          v-else-if="attr == 'ToiletNumber'"
          :class="{ disText: true, fcolor: store.state.toiletNumberText && store.state.toiletNumberText != lang.pleSelect }"
        ></span>
        <span
          v-text="store.state.UnitFloorText ? store.state.UnitFloorText : lang.pleSelect"
          v-else-if="attr == 'unitFloor'"
          :class="{
            disText: true,
            fcolor: store.state.UnitFloorText && store.state.UnitFloorText != lang.pleSelect,
            unSelectColor: this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0 && this.attr == 'unitFloor',
          }"
        ></span>
        <span
          v-text="$parent.info.estateName ? selectText : lang.pleSelect"
          v-else-if="attr == 'estateName'"
          :class="{ disText: true, unfcolor: !$parent.info.estateName && selectText != lang.pleSelect }"
        ></span>
        <span
          v-text="$parent.info.RentLabel ? store.state.rentText : lang.pleSelect"
          v-else-if="attr == 'RentLabel'"
          :class="{ disText: true, unfcolor: !$parent.info.estateName && selectText != lang.pleSelect }"
        ></span>
        <span v-text="selectText" v-else class="disText"></span>
        <van-icon name="arrow" />
      </div>

      <!-- 平面图plat一行回显  -->
      <div :class="['plat-conetnt_xia', { noborder: hideBorder }, { disableText: disabled }, { fcolor: selectText != this.lang.pleSelect }]" v-if="type === 'platimg'" @click="select">
        <!-- <span class="required" style="color: #ed1818">*</span> -->
        <span class="plat_h" v-text="title"></span>
        <div class="House730">{{ lang.house730 }}</div>
      </div>
      <!-- 平面图回显 -->
      <div :class="['plat-conetnt', { noborder: hideBorder }, { disableText: disabled }, { fcolor: selectText != this.lang.pleSelect }]" v-if="type === 'platimg'" @click="select">
        <div v-if="store.state.platimg && store.state.platimg.length != 0" v-text="`${lang.chooseImg}${store.state.platimg.length}${lang.zhang}`"></div>
        <span v-text="selectText" v-else class="disText"> </span>
        <van-icon name="arrow" />
      </div>

      <!-- 标签一行回显  -->
      <div :class="['tag-conetnt', { noborder: hideBorder }, { disableText: disabled }, { fcolor: selectText != this.lang.pleSelect }]" v-if="type === 'tags'" @click="select">
        <span class="tags_h" v-text="title"></span>
        <span class="tagsText" v-if="store.state.tagcount != 0" v-text="`${lang.alsel}${store.state.tagcount}${lang.ected}`"></span>
        <span v-else v-text="selectText" class="tagsText"> </span>
        <van-icon name="arrow" />
      </div>
      <!-- input输入框 -->

      <div :class="['cell-input', { noborder: hideBorder }]" v-else-if="type === 'text-info' || type === 'text-user' || type === 'telphone' || type === 'customerTel' || type === 'owner-name'">
        <div v-if="false">{{ $parent.info }}</div>
        <div v-if="type == 'text-info' && (attr == 'buildingNameWithCulture' || attr == 'roomNoWithCulture')">
          <input :class="{ disabledColor: disabled }" :maxlength="max" :type="textType" :disabled="disabled" :placeholder="lang.pleInput" :value="$parent.info[attr]" @input="inputEvent($event)" />
        </div>
        <div v-else>
          <!-- 添加常用词，弹出第三方页面 -->
          <!-- 物业编号输入框 -->
          <input
            :class="{ disabledColor: disabled }"
            :maxlength="max"
            :type="textType"
            :disabled="disabled"
            v-if="type == 'text-info' && attr !== 'estateAddress' && attr == 'propertyNo' && attr != 'buildingAge'"
            :placeholder="lang.propertyNoPleSelect"
            :value="$parent.info[attr]"
            @input="inputEvent($event)"
            @blur="sellPrice($event, $parent.info[attr])"
          />
          <input
            :class="{ disabledColor: disabled }"
            :maxlength="max"
            :type="textType"
            :disabled="disabled"
            ref='elsalePrice'
            v-if="type == 'text-info' && attr !== 'estateAddress' && attr != 'propertyNo' && attr != 'buildingAge'"
            :placeholder="lang.pleInput"
            :value="$parent.info[attr]"
            @input="inputEvent($event)"
            @blur="sellPrice($event, $parent.info[attr])"
          />
          <input
            :class="{ disabledColor: disabled }"
            :maxlength="max"
            :type="textType"
            :disabled="disabled"
            v-if="type == 'text-info' && attr === 'estateAddress' && attr != 'propertyNo' && attr != 'buildingAge'"
            :placeholder="this.$parent.isEstateAddFlag ? lang.estateAddressPlaceHolder : this.$parent.info.estateID > 0 ? '' : lang.estateAddressPlaceHolder"
            v-model="estateAddressValue"
            @input="inputEvent($event)"
            @blur="sellPrice($event, $parent.info[attr])"
          />
          <input
            :class="{ disabledColor: disabled }"
            :maxlength="max"
            :type="textType"
            :disabled="disabled"
            v-if="type == 'text-info' && attr !== 'estateAddress' && attr != 'propertyNo' && attr == 'buildingAge'"
            :placeholder="this.$parent.isBuildingAgeFlag ? lang.pleInput : this.$parent.info.estateID > 0 ? '' : lang.pleInput"
            :value="$parent.info[attr]"
            @input="inputEvent($event)"
            @blur="sellPrice($event, $parent.info[attr])"
          />
          <input
            :class="{ disabledColor: disabled }"
            :disabled="disabled"
            v-if="type == 'telphone'"
            :placeholder="lang.pleInput"
            :value="$parent.userInfo[attr]"
            oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 8)"
            @input="inputEvent($event)"
          />
          <input
            :class="{ disabledColor: disabled }"
            :disabled="disabled"
            v-if="type == 'customerTel'"
            :placeholder="lang.pleInput"
            :value="$parent.userInfo[attr]"
            oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 11)"
            @input="inputEvent($event)"
          />
          <input
            :class="{ disabledColor: disabled }"
            :disabled="disabled"
            v-if="type == 'text-user'"
            :placeholder="lang.pleInput"
            :value="$parent.userInfo[attr]"
            @input="$parent.userInfo[attr] = $event.target.value"
            maxlength="45"
          />
          <input
            class="owner_name"
            :class="{ disabledColor: disabled }"
            :disabled="disabled"
            v-if="type == 'owner-name'"
            :placeholder="lang.pleInput"
            :value="$parent.userInfo[attr]"
            @input="$parent.userInfo[attr] = $event.target.value"
            maxlength="45"
          />
        </div>
      </div>
      <!-- textarea -->
      <div :class="['cell-textarea', { noborder: hideBorder }]" v-else-if="type === 'textarea'">
        <textarea rows="5" cols="30" :placeholder="lang.pleInput" :maxlength="max" :value="$parent.info[attr]" @input="$parent.info[attr] = $event.target.value"></textarea>
        <p class="maxtip" v-if="$parent.info[attr]">{{ $parent.info[attr].length }}/{{ max }}</p>
      </div>
    </div>
    <!-- 弹出层 --- 选择物业类型 -->
    <div class="select-most" v-show="showChoose">
      <!-- @click-overlay="clearSelect('clickPop')" -->
      <van-popup position="bottom" v-model="showChoose" class="popup" :close-on-click-overlay="true" @click-overlay="selects.childData = $parent.info.subCategory">
        <!-- 付款方式展示 -->
        <!-- <div v-if="attr == 'way'" class="payway">
          <div class="select-title">{{ lang.payway }}</div>
          <section>
            <ul>
              <li v-for="item in pay" :key="item.id" @click="selectWarp(item)">
                <div>
                  <img :src="item.img" alt="" :class="item.attr == 'paypal' ? 'paypal-img' : ''" />
                  <span :class="item.attr == 'paypal' ? 'paypal-text' : item.attr == 'coin' ? 'coin-text' : ''">{{ item.text }}</span>
                  <svg class="icon icon_ver" aria-hidden="true">
                    <use :xlink:href="item.svg" />
                  </svg>
                </div>
                <van-radio checked-color="#ee0a24" :name="item.attr" v-model="selects.warpData"></van-radio>
              </li>
            </ul>
          </section>
        </div> -->
        <!-- 起租日选择 -else-->
        <div v-if="attr == 'beginRentTime'">
          <van-datetime-picker v-model="currentDate" type="date" @confirm="confirm" @cancel="cancel" :confirm-button-text="lang.confirm" />
        </div>
        <!-- 期数盘选择 -->
        <div v-else-if="attr == 'phaseWithCulture'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ lang.selectText }}{{ lang.housenum }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li :class="{ check: estate.phaseWithCulture == item.phaseWithCulture }" v-for="item in chooseData.children" :key="item.dictionaryValue" @click="selectWarp(item)">
                <span>{{ item.phaseWithCulture }}</span>
                <i class="line" v-show="estate.phaseWithCulture == item.phaseWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 座数选择 -->
        <div v-else-if="attr == 'buildingNameWithCulture'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ lang.selectText }}{{ lang.buildNum }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li
                :class="{ check: buildData.phaseAndBuildingNameWithCulture == item.phaseAndBuildingNameWithCulture }"
                v-for="item in chooseData.children"
                :key="item.dictionaryValue"
                @click="selectWarp(item)"
              >
                <span>{{ item.phaseAndBuildingNameWithCulture }}</span>
                <i class="line" v-show="buildData.phaseAndBuildingNameWithCulture == item.phaseAndBuildingNameWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 楼层选择 -->
        <div v-else-if="attr == 'buildFloor'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ lang.selectText }}{{ lang.height1 }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li :class="{ check: floorSelectData.floorNameWithCulture == item.floorNameWithCulture }" v-for="item in chooseData.children" :key="item.dictionaryValue" @click="selectWarp(item)">
                <span>{{ item.floorNameWithCulture }}</span>
                <i class="line" v-show="floorSelectData.floorNameWithCulture == item.floorNameWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 高中低层选择 -->
        <div v-else-if="attr == 'unitFloor'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ lang.selectText }}{{ lang.height }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li
                :class="{ check: unitFloorData.dictionaryNameWithCulture == item.dictionaryNameWithCulture }"
                v-for="item in chooseData.children"
                :key="item.dictionaryValue"
                @click="selectWarp(item)"
              >
                <span>{{ item.dictionaryNameWithCulture }}</span>
                <i class="line" v-show="unitFloorData.dictionaryNameWithCulture == item.dictionaryNameWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 单位选择 -->
        <div v-else-if="attr == 'roomNoWithCulture'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ lang.selectText }}{{ lang.unitD }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li :class="{ check: roomNoData.roomNoWithCulture == item.roomNoWithCulture }" v-for="item in chooseData.children" :key="item.dictionaryValue" @click="selectWarp(item)">
                <span>{{ item.roomNoWithCulture }}</span>
                <i class="line" v-show="roomNoData.roomNoWithCulture == item.roomNoWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 房间数目选择 -->
        <div v-else-if="attr == 'RoomNumber'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ chooseData && chooseData.dictionaryNameWithCulture ? chooseData.dictionaryNameWithCulture : '' }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li
                :class="{ check: roomNumberData.dictionaryNameWithCulture == item.dictionaryNameWithCulture }"
                v-for="item in chooseData.children"
                :key="item.dictionaryValue"
                @click="selectWarp(item)"
              >
                <span>{{ item.dictionaryNameWithCulture }}</span>
                <i class="line" v-show="roomNumberData.dictionaryNameWithCulture == item.dictionaryNameWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 洗手间数目选择 -->
        <div v-else-if="attr == 'ToiletNumber'" style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ chooseData && chooseData.dictionaryNameWithCulture ? chooseData.dictionaryNameWithCulture : '' }}</div>
          <section>
            <ul class="col-left" style="width: 100%" v-if="chooseData && chooseData.children">
              <li
                :class="{ check: toiletNumberData.dictionaryNameWithCulture == item.dictionaryNameWithCulture }"
                v-for="item in chooseData.children"
                :key="item.dictionaryValue"
                @click="selectWarp(item)"
              >
                <span>{{ item.dictionaryNameWithCulture }}</span>
                <i class="line" v-show="toiletNumberData.dictionaryNameWithCulture == item.dictionaryNameWithCulture"></i>
              </li>
            </ul>
          </section>
        </div>
        <!-- 其他选择展示 -->
        <div v-else style="display: flex; flex-direction: column; flex: 1">
          <div class="select-title">{{ chooseData && chooseData.dictionaryNameWithCulture ? chooseData.dictionaryNameWithCulture : '' }}</div>
          <div class="select-content" v-if="attr == 'isHideCompanyInfo'">{{ chooseData.dictionaryContent }}</div>
          <!-- 物业类型选择 两列布局  其余一列-->
          <section>
            <!-- 租房 其他選項 展示 -->
            <ul class="col-left" v-if="attr == 'RentLabel' && chooseData && chooseData.children" style="width: 100%">
              <template v-for="item in chooseData.children">
                <div v-if="(item.rentalType==0 || item.rentalType==2)&&(item.displayType==0 || item.displayType==2)">
                  <li
                    :class="{ check: Array.isArray(selects.warpData) && selects.warpData.includes(item.dictionaryValue), disabledColor: rentLabelDis && (item.dictionaryValue == '5' || item.dictionaryValue == '6') }"
                    v-if="!$parent.info.subCategory.includes('19') || item.itemName !== '8'"
                    :key="item.dictionaryValue"
                    @click="selectWarp(item)"
                    >
                      <!-- <div>
                        <span>{{ item.dictionaryNameWithCulture ? item.dictionaryNameWithCulture : '' }}</span>
                        <i class="line" v-show="Array.isArray(selects.warpData) && selects.warpData.indexOf(item.dictionaryValue) > -1"></i>
                      </div> -->
                    <div v-if="item.itemName == '8'">
                      <span style="display: flex; align-items: center"
                        >{{ item.dictionaryNameWithCulture ? item.dictionaryNameWithCulture : '' }}
                        <img style="width: 14px; height: 14px; margin-left: 4px" src="../../assets/tip-icon@2x.png" alt="" @click.stop="tipsEven(item.itemName)" />
                      </span>
                      <i class="line" v-show="Array.isArray(selects.warpData) && selects.warpData.indexOf(item.dictionaryValue) > -1"></i>
                    </div>
                    <div v-else>
                      <span>{{ item.dictionaryNameWithCulture ? item.dictionaryNameWithCulture : '' }}</span>
                      <i class="line" v-show="Array.isArray(selects.warpData) && selects.warpData.indexOf(item.dictionaryValue) > -1"></i>
                    </div>
                  </li>
                </div>
              </template>
            </ul>
            <!-- 楼盘类型选择 -->
            <ul
              class="col-left"
              v-if="(!this.$route.query.type || (this.$route.query.type != 'copy' && this.$route.query.type != 'edit')) && attr == 'PropertyCategory' && chooseData && chooseData.children"
              :style="{ width: '50%' }"
            >
              <template v-for="item in chooseData.children">
                <li v-if="item.displayType == 0 || item.displayType == 2" :class="{ check: selects.warpData == item.dictionaryValue }"  :key="item.dictionaryValue" @click="selectWarp(item, 'push')">
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <i class="line" v-show="selects.warpData == item.dictionaryValue"></i>
                </li>
              </template>
            </ul>
            <ul
              class="col-left"
              v-if="(this.$route.query.type == 'copy' || this.$route.query.type == 'edit') && attr == 'PropertyCategory' && chooseData && chooseData.children"
              :style="{ width: '50%' }"
            >
              <li :class="{ check: selects.warpData == item.dictionaryValue }" v-for="item in chooseData.children" :key="item.dictionaryValue">
                <div v-if="$parent.info.estateSrcList.indexOf(item.itemName * 1) != -1" @click="selectWarp(item, 'push')">
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <i class="line" v-show="selects.warpData == item.dictionaryValue"></i>
                </div>
                <div v-else style="color: #b2b2b2">
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <i class="line" v-show="selects.warpData == item.dictionaryValue"></i>
                </div>
              </li>
            </ul>
            <!-- 其他展示 -->

            <ul
              class="col-left"
              v-if="attr != 'RentLabel' && attr != 'PropertyCategory' && chooseData && chooseData.children"
              :style="{ width: attr == 'PropertyCategory' || attr == 'isShowTel' ? '50%' : '100%' }"
            >
              <li :class="{ check: selects.warpData == item.dictionaryValue }" v-for="item in chooseData.children" :key="item.dictionaryValue" @click="selectWarp(item, 'push')">
                <span>{{ item.dictionaryNameWithCulture }}</span>
                <i class="line" v-show="selects.warpData == item.dictionaryValue"></i>
              </li>
            </ul>
            <ul v-if="attr == 'PropertyCategory'" class="col-right" v-show="chooseChild.length">
              <!-- 楼盘类型多选 -->
              <van-checkbox-group v-if="categoryType == '1'" v-model="selects.childData" :max="2">
                <template v-for="item in chooseChild">
                  <li
                    :class="{ check: selects.childData.includes(item.dictionaryValue) }" 
                    v-if="item.itemName == '19' && $parent.info.rentalType == 2" 
                    :key="item.dictionaryValue"
                    style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px"
                    >
                      <van-checkbox checked-color="#ee0a24" :name="item.dictionaryValue" :disabled="true">{{ item.dictionaryNameWithCulture }}<img style="width: 14px; height: 14px; margin: 2px 0 0 4px; z-index: 1000; position: absolute;" src="../../assets/tip-icon@2x.png" alt="" @click="tipsEven(item.itemName)" /></van-checkbox>
                    </li>
                  <li
                    :class="{ check: selects.childData.includes(item.dictionaryValue) }" 
                    v-else-if="item.itemName !== '19' || $parent.info.rentalType == 2"
                    style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px"
                  >
                      <van-checkbox checked-color="#ee0a24" :name="item.dictionaryValue" :disabled="cateDisable_PropertyCategory(item)">{{ item.dictionaryNameWithCulture }}</van-checkbox>
                    </li>
                </template>
              </van-checkbox-group>
              <!-- 其他类型多选 -->
              <van-checkbox-group v-else v-model="selects.childData">
                <li :class="{ check: selects.childData.includes(item.dictionaryValue) }" v-for="item in chooseChild" :key="item.dictionaryValue">
                  <van-checkbox checked-color="#ee0a24" :name="item.dictionaryValue" :disabled="cateDisable(item)">{{ item.dictionaryNameWithCulture }}</van-checkbox>
                </li>
              </van-checkbox-group>
            </ul>
            <ul v-else-if="attr == 'isShowTel'" class="col-right" v-show="chooseChild.length">
              <van-checkbox-group v-model="selects.childData" :max="2">
                <li :class="{ check: selects.childData.includes(item.dictionaryValue) }" v-for="item in chooseChild" :key="item.dictionaryValue" @click="pickWhatsApp(item)">
                  <van-checkbox checked-color="#ee0a24" :name="item.dictionaryValue" :disabled="cateDisable(item)">{{ item.dictionaryNameWithCulture }}</van-checkbox>
                </li>
              </van-checkbox-group>
            </ul>
            <ul v-else class="col-right" v-show="chooseChild.length">
              <van-checkbox-group v-model="selects.childData" :max="2">
                <li :class="{ check: selects.childData.includes(item.dictionaryValue) }" v-for="item in chooseChild" :key="item.dictionaryValue">
                  <!-- <span></span> -->
                  <van-checkbox checked-color="#ee0a24" :name="item.dictionaryValue" :disabled="cateDisable(item)">{{ item.dictionaryNameWithCulture }}</van-checkbox>
                </li>
              </van-checkbox-group>
            </ul>
          </section>
        </div>

        <!-- 确定 -->
        <div class="select-bottom" v-show="attr != 'beginRentTime'">
          <div class="cancel-select" @click="clearSelect" v-show="attr != 'way'">{{ lang.clearAll }}</div>
          <van-button type="danger" @click="confrim" :class="attr == 'way' ? 'confrimWidth' : ''">{{ lang.confirm }} </van-button>
        </div>
      </van-popup>
    </div>
    <van-dialog v-model="tipsDialog" :confirm-button-text="lang.keyCon" class="dialogWord tipsDialog" closeOnClickOverlay>
      <p class="tipsKeyWord">{{ lang.tipsKeyWordTop }}</p>
      <p class="tipsKeyWord">{{ lang.tipsKeyWord }}</p>
    </van-dialog>
    <van-dialog v-model="tipsDialog_GongJv" :confirm-button-text="lang.keyCon" class="dialogWord tipsDialog" closeOnClickOverlay>
      <p class="tipsKeyWord">{{ lang.tipsKeyWord_GongJv }}</p>
    </van-dialog>
    <van-dialog v-model="tipsShow" :confirm-button-text="lang.keyCon" class="dialogWord tipsDialog" closeOnClickOverlay style="text-align:center;">
      <p class="tipsKeyWord">{{ lang.addressTips }}</p>
    </van-dialog>
    <van-dialog v-model="unitFloorTipsShow" :confirm-button-text="lang.keyCon" class="dialogWord tipsDialog" closeOnClickOverlay style="text-align:center;">
      <p class="tipsKeyWord">{{ lang.unitFloorTips }}</p>
    </van-dialog>
    <!-- 售价超额 -->
    <van-dialog v-model="showPriceTip" class="editDialog" closeOnClickOverlay style="text-align:center;">
      <!-- 1000w  10million  -->
      <!--  : lang.saleOm  -->
      <p class="editPriceText" v-if="url.indexOf('en-us') > -1 && $parent.info['PropertyCategory'] == 4 && $parent.info['paidSalePrice']<10000 ">{{ lang.saleO }}{{$parent.info['paidSalePrice'] /100}}{{ lang.saleOm }}</p>
      <p class="editPriceText" v-else>{{ lang.saleO }}{{$parent.info['PropertyCategory'] == 4 && $parent.info['paidSalePrice']<10000 ? $parent.info['paidSalePrice']+ lang.saleOfi:$parent.info['paidSalePrice']/(url.indexOf('en-us') > -1? 100000:10000)+lang.saleOt}}</p>
      <p class="editPriceText editPrice">{{lang.saleOs}}</p>
      <van-button class='editBut editbutsize' @click="focusPrice">{{lang.saleOf}} </van-button>
      <van-button type="danger" class="editbutsize" @click="showPriceDiff">{{ lang.saleOth }} </van-button>
    </van-dialog>
    <!-- 业主盘上限3个弹出框 -->
    <van-dialog v-model="freeYezhuPopup" :confirm-button-text="lang.keyCon" class="dialogWord tipsDialog" closeOnClickOverlay>
      <p v-html="lang.freeText" class="free_tipsKeyWord"></p>
    </van-dialog>
  </div>
</template>

<script>
import lang from './../../../common/language/post';
import { Dialog, Toast } from 'vant';
export default {
  props: {
    titleBeh:String,
    type: String,
    title: String,
    required: Boolean,
    tip: null,
    attr: String,
    target: String,
    disabled: Boolean,
    max: String,
    value: String,
    parentID: Number,
    textType: {
      default: 'text',
      type: String,
    },
    hideBorder: {
      default: false,
      type: Boolean,
    },
    buyList: {
      type: Array,
      default: () => []
    },
    rentList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      shopTypeData: false,
      renewalType: false, // 是否可选免费支付方式
      selectedPayment: '',
      propertys: [],
      arrRent: [],
      prohibitSelection: '',
      showPriceTip:false,
      tipsShow: false,
      unitFloorTipsShow: false,
      categoryType: '',
      buildData: '', //座数数据
      floorSelectData: '', // 选中的楼层数据
      unitFloorData: '', // 选中的高中低数据
      roomNoData: '', // 单位数据
      roomNumberData: '', // 房间数目数据
      toiletNumberData: '', // 洗手间数据
      estateAddressValue: this.$parent.info['estateAddress'],
      videoText: lang.pleInput,
      lang,
      url: document.URL,
      rentLabelDis: false,
      inputData: '', //表单数据
      selectText: lang.pleSelect,
      showChoose: false,
      chooseData: {},
      chooseChild: [],
      estate: {},
      currentDate: new Date(),
      orignprice: 0,
      orignUnpaidPrice:0,
      orignrprice: 0,
      isAliPay: true, //支付宝的支付开关，并且通知接口同时改筛选
      isWePay: true, // 微信的支付开关，并且通知接口同时改筛选
      pay: [
        {
          img: require('../../assets/free@2x.png'),
          text: `(${lang.free})`,
          id: 1,
          attr: 'free',
        },
        {
          img: require('../../assets/gold.png'),
          text: lang.Coin,
          id: 1,
          attr: 'coin',
        },
        {
          img: require('../../assets/postCard.png'),
          text: lang.cre,
          id: 3,
          attr: 'paydollar',
        },
        {
          img: require('../../assets/pay01.png'),
          text: ``,
          id: 0,
          attr: 'paypal',
        },
        {
          img: require('../../assets/alipay@2x.png'),
          text: `(${lang.visa})`,
          id: 0,
          attr: 'alipay',
        },
        {
          img: require('../../assets/wechat@2x.png'),
          text: `(${lang.visa})`,
          id: 0,
          attr: 'wepay',
        },
        {
          img: require('../../assets/banktran.png'),
          // svg: '#icon-yinhangzhuanzhang',
          text: lang.transfer,
          id: 2,
          attr: 'trans',
        },
      ],
      selects: {
        warpData: -2, //记录父值
        childData: [], //记录子值
      },
      tipsDialog: false,
      tipsDialog_GongJv: false,
      whatsAppArr:[],
      freeYezhuPopup: false,
    };
  },
  watch: {
    '$parent.buyList': {
      immediate: true, // 立即执行一次
      handler(newBuyList, oldBuyList) {
        if (newBuyList && this.$parent.rentList) {
          // 在这里执行依赖于 buyList 和 rentList 的逻辑
          this.handleBuyRentLists();
        }
      }
    },
    '$parent.rentList': {
      immediate: true,
      handler(newRentList, oldRentList) {
        if (newRentList && this.$parent.buyList) {
          // 在这里执行依赖于 buyList 和 rentList 的逻辑
          this.handleBuyRentLists();
        }
      }
    }
  },
  async created() {
    this.propertys = this.$parent.propertys
    const ua = navigator.userAgent.toLowerCase();
    const platform = ua.indexOf('house730') > -1 ? 'app' : '';
    if (platform == 'app') {
      const sys = ua.indexOf('iphone') > -1 || ua.indexOf('ios') > -1 ? 'ios' : 'android';
      if (sys == 'ios') {
        this.isAliPay = true;
        this.isWePay = false;
      } else {
        this.isAliPay = true;
        this.isWePay = false;
      }
    } else {
      this.isAliPay = true;
      this.isWePay = false;
    }
    if (this.$parent.info.PropertySource === 2) {
      if (!this.isAliPay) {
        this.pay = [
          {
            img: require('../../assets/gold.png'),
            text: lang.Coin,
            id: 1,
            attr: 'coin',
          },
          {
            img: require('../../assets/postCard.png'),
            text: lang.cre,
            id: 3,
            attr: 'paydollar',
          },
          {
            img: require('../../assets/pay01.png'),
            text: ``,
            id: 0,
            attr: 'paypal',
          },
          {
            img: require('../../assets/wechat@2x.png'),
            text: `(${lang.visa})`,
            id: 0,
            attr: 'wepay',
          },
          {
            img: require('../../assets/banktran.png'),
            // svg: '#icon-yinhangzhuanzhang',
            text: lang.transfer,
            id: 2,
            attr: 'trans',
          },
        ];
      }
      if (!this.isWePay) {
        this.pay = [
          {
            img: require('../../assets/gold.png'),
            text: lang.Coin,
            id: 1,
            attr: 'coin',
          },
          {
            img: require('../../assets/postCard.png'),
            text: lang.cre,
            id: 3,
            attr: 'paydollar',
          },
          {
            img: require('../../assets/pay01.png'),
            text: ``,
            id: 0,
            attr: 'paypal',
          },
          {
            img: require('../../assets/alipay@2x.png'),
            text: `(${lang.visa})`,
            id: 0,
            attr: 'alipay',
          },
          {
            img: require('../../assets/banktran.png'),
            // svg: '#icon-yinhangzhuanzhang',
            text: lang.transfer,
            id: 2,
            attr: 'trans',
          },
        ];
      }
    } else {
      if (!this.isAliPay) {
        this.pay = [
          {
            img: require('../../assets/free@2x.png'),
            text: `(${lang.free})`,
            id: 1,
            attr: 'free',
          },
          {
            img: require('../../assets/gold.png'),
            text: lang.Coin,
            id: 1,
            attr: 'coin',
          },
          {
            img: require('../../assets/postCard.png'),
            text: lang.cre,
            id: 3,
            attr: 'paydollar',
          },
          {
            img: require('../../assets/pay01.png'),
            text: ``,
            id: 0,
            attr: 'paypal',
          },
          {
            img: require('../../assets/wechat@2x.png'),
            text: `(${lang.visa})`,
            id: 0,
            attr: 'wepay',
          },
          {
            img: require('../../assets/banktran.png'),
            // svg: '#icon-yinhangzhuanzhang',
            text: lang.transfer,
            id: 2,
            attr: 'trans',
          },
        ];
      }
      if (!this.isWePay) {
        this.pay = [
          {
            img: require('../../assets/free@2x.png'),
            text: `(${lang.free})`,
            id: 1,
            attr: 'free',
          },
          {
            img: require('../../assets/gold.png'),
            text: lang.Coin,
            id: 1,
            attr: 'coin',
          },
          {
            img: require('../../assets/postCard.png'),
            text: lang.cre,
            id: 3,
            attr: 'paydollar',
          },
          {
            img: require('../../assets/pay01.png'),
            text: ``,
            id: 0,
            attr: 'paypal',
          },
          {
            img: require('../../assets/alipay@2x.png'),
            text: `(${lang.visa})`,
            id: 0,
            attr: 'alipay',
          },
          {
            img: require('../../assets/banktran.png'),
            // svg: '#icon-yinhangzhuanzhang',
            text: lang.transfer,
            id: 2,
            attr: 'trans',
          },
        ];
      }
    }
    if (this.$parent.PropertyCategory == 4) {
      this.store.commit('setSelectFloorData', this.floorSelectData);
    }
    if (this.$parent.info['PropertyCategory'] == 2 || this.$parent.info['PropertyCategory'] == 3) {
      this.shopTypeData = true
      this.store.commit('setShopTypeData', this.shopTypeData);
    } else {
      this.shopTypeData = false
      this.store.commit('setShopTypeData', this.shopTypeData);
    }
    if (this.propertys && this.propertys.length > 0 && this.$parent.mode == '2') {
      this.renewalType = this.propertys.some(property => property.propertyID === this.$parent.info.propertyID);
    }
    if (this.type == 'select') {
      if (this.attr == 'phaseWithCulture' || this.attr == 'buildingNameWithCulture') {
        if (this.$route.query.type !== 'edit') {
          if (!this.$parent.info[this.attr]) return;
          if (this.attr == 'phaseWithCulture') {
            this.$store.commit('setPhaseWarpData', this.store.state.phaseText);
          }
        } else {
          if (this.attr == 'phaseWithCulture') {
            this.$store.commit('setPhaseWarpData', this.store.state.phaseText);
          }
        }
        if (this.attr == 'phaseWithCulture') {
          this.store.commit('setPhaseSelectText', this.store.state.phaseText ? this.store.state.phaseText : '');
        } else {
          this.store.commit('setBuildSelectText', this.store.state.buildText ? this.store.state.buildText : '');
        }
        return;
      }
    
      if (this.attr == 'estateName' && this.$parent.info.estateName) {
        this.selectText = this.$parent.info.estateName;
        return;
      }

      if (this.attr == 'isShowTel' || this.attr == 'isHideCompanyInfo') {
        this.chooseData = this.$parent.lang[this.attr];
        // 初始 -- 默认选中whatsApp
        if(this.chooseData.children[0].dictionaryValue == true  && (this.$parent.mode == 'post')){
         this.whatsAppArr = this.chooseData.children[0].children
        }
        if(this.$parent.mode == 'post'){
          this.selects.warpData = true;
          this.selects.childData.push(1);
          this.chooseChild = this.whatsAppArr
        }
        if (this.attr == 'isShowTel') {
          if (this.$parent.userInfo.isShowWeChat) {
            this.selects.childData.push(2);
          }
          if (this.$parent.userInfo.isShowWhatsApp) {
            this.selects.childData.push(1);
          }
        }
      } else {
        if (this.$parent.dictionary.hasOwnProperty(this.attr)) {
          this.chooseData = this.$parent.dictionary[this.attr];
        }
      }
      // 选择初始化页面如果有值
      if (this.$parent.info.hasOwnProperty(this.attr) || this.$parent.userInfo.hasOwnProperty(this.attr)) {
        this.selects.warpData = this.$parent.info[this.attr] || String(this.$parent.userInfo[this.attr]) || '';
        if (this.attr == 'PropertyCategory') {
          if (this.$parent.info.estateSrcList && this.$parent.info.estateSrcList.indexOf(this.$parent.info.PropertyCategory) == -1) {
            this.clearSelect();
            this.$parent.info.PropertyCategory = -2;
          }
          this.selects.childData = this.$parent.info.subCategory || [];
          await this.axios.get(this.pub.getApi().GetPropertySubCategoryNotAllow)
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.prohibitSelection = res.data.result
            }
          });
        }
        if (this.attr == 'RentLabel') {
          this.selects.warpData = this.$parent.info[this.attr] || [];
          this.parseRent('RentLabel');
          return;
        }
        if (this.attr == 'unitFloor') {
          this.selectText = Boolean(this.$parent.info.unitFloor) ? this.$parent.info.unitFloor : '';
          return;
        }
        if (this.attr == 'ToiletNumber') {
          if (this.chooseData.children) {
            this.chooseData.children.forEach((item) => {
              if (item.dictionaryValue == this.selects.warpData) {
                this.selectText = item.dictionaryNameWithCulture;
              }
            });
          }
          return;
        }
        this.parseValue();
      }
    }
    if (this.attr == 'beginRentTime') {
      if (this.$parent.info.beginRentTime > 0) {
        this.selectText = new Date(parseInt(this.$parent.info.beginRentTime) * 1000).toLocaleDateString();
        this.currentDate = new Date(new Date(parseInt(this.$parent.info.beginRentTime) * 1000).toLocaleDateString());
      } else {
        this.selectText = this.lang.pleSelect;
      }
      return;
    }
    // this.handleBuyRentLists()
    // if (this.attr == 'way') {
    //   if (this.$parent.info.PropertySource === 1) {
    //     if (this.$parent.info.topType.startsWith('Star')) {
    //       this.$store.commit('setPayMent', 'coin');
    //       this.selects.warpData = this.$store.state.payMent || 'coin';
    //     } else {
    //       let lengthNumber = this.buyList.length + this.rentList.length
    //       console.log("lengthNumber",lengthNumber)
    //       console.log("this.buyList.length",this.buyList.length)
    //       console.log("this.rentList.length",this.rentList.length)
    //       if (lengthNumber < 3) {
    //         this.$store.commit('setPayMent', 'free');
    //         this.selects.warpData = this.$store.state.payMent || 'free';
    //       } else {
    //         if (this.renewalType) {
    //           this.$store.commit('setPayMent', 'free');
    //           this.selects.warpData = this.$store.state.payMent || 'free';
    //         } else {
    //           this.$store.commit('setPayMent', 'coin');
    //           this.selects.warpData = this.$store.state.payMent || 'coin';
    //         }
    //       }
    //     }
    //   } else {
    //     this.$store.commit('setPayMent', 'coin');
    //     this.selects.warpData = this.$store.state.payMent || 'coin';
    //   }
    // }
    this.orignprice = this.$parent.orignprice;
    this.orignUnpaidPrice = this.$parent.orignUnpaidPrice
    this.orignrprice = this.$parent.orignrprice;
  },
  mounted () {
    this.updateWay()
  },
  activated() {
    this.$parent.info.buildingNameWithCulture = this.store.state.buildText;
    this.$parent.info.buildFloor = this.store.state.floorText;
    this.$parent.info.roomNoWithCulture = this.store.state.roomNoWithCulture;
    this.$parent.info.phaseWithCulture = this.store.state.phaseWarpData;
    this.$parent.info.unitFloor = this.store.state.UnitFloorText;
    if (this.attr == 'estateName' || this.attr == 'estateAddress') {
      if (this.attr == 'estateAddress') {
        this.$parent.info.estateAddress = this.url.indexOf('en-us') > -1 && Boolean(this.$parent.info.estateAddressEN) ? this.$parent.info.estateAddressEN : this.$parent.info.estateAddress;
        this.estateAddressValue = this.url.indexOf('en-us') > -1 && Boolean(this.$parent.info.estateAddressEN) ? this.$parent.info.estateAddressEN : this.$parent.info.estateAddress;
      }
      if (this.attr == 'estateName') {
        if (this.store.state.estateBuildNum.length == 0 && this.$parent.info.estateName && !this.store.state.estateData.isCutomadded) {
          this.$parent.buildVisible = false;
        } else {
          this.$parent.buildVisible = true;
        }
        // this.$emit('build-checked')
        if (this.$parent.info.estateID == 0) {
          this.$parent.info.estateName = this.url.indexOf('en-us') > -1 ? this.$parent.info.estateNameEN ? this.$parent.info.estateNameEN : this.$parent.info.estateName : this.$parent.info.estateName;
          this.selectText = this.url.indexOf('en-us') > -1 ? this.$parent.info.estateNameEN ? this.$parent.info.estateNameEN : this.$parent.info.estateName : this.$parent.info.estateName;
        } else {
          this.$parent.info.estateName = this.url.indexOf('en-us') > -1 ? this.$parent.info.estateNameEN : this.$parent.info.estateName;
          this.selectText = this.url.indexOf('en-us') > -1 ? this.$parent.info.estateNameEN : this.$parent.info.estateName;
        }
        this.$emit('get-select', 'estateName');
        if(this.$parent.info.estateID || this.$parent.info.estateID == 0){
          this.axios.post(this.pub.getApi().GetStationDuration,{estateId:this.$parent.info.estateID}).then(res => {
            if(res.data.result == -1 || res.data.result.length == 0 || res.data.result >15){
              let changeEstTags = this.store.state.tags
              let changeInfoTags = this.store.state.propertyTags
              for (let i = 0; i < changeEstTags.length; i++) {
                if(changeEstTags[i].key == 23 || changeEstTags[i].key == 51){
                  changeEstTags.splice(i,1)
                }
              }
              for (let i = 0; i < changeInfoTags.length; i++) {
                if(changeInfoTags[i] == 23 || changeInfoTags[i] == 51){
                  changeInfoTags.splice(i,1)
                }
              }
              this.store.commit("setTags",changeEstTags)
              this.store.commit("setTagsCount",changeEstTags.length)
              this.store.commit("setTagsConfig",{propertyTags:changeInfoTags})
            }
          });
        }
      }
      return;
    }
    /*期数再次进入到页面 对比vuex中的选项和当前页面的选项 如果不一致 清空选择重新赋值 */

    if (this.attr == 'phaseWithCulture') {
      if (this.store.state.estatePhase.length) {
        if (JSON.stringify(this.store.state.estatePhase) != JSON.stringify(this.chooseData.children)) {
          this.chooseData = { title: this.lang.housenum, children: this.store.state.estatePhase };
          this.$parent.info.phaseWithCulture = '';
        } else {
          this.chooseData = { title: this.lang.housenum, children: this.store.state.estatePhase };
        }
      } else {
        this.$parent.info.phaseWithCulture = '';
      }
    }
  },
  methods: {
    handleBuyRentLists() {
      // 处理 buyList 和 rentList 的逻辑
      // 可以放置原先在 created 钩子中的相关代码
      if (this.attr == 'way') {
        if (this.$parent.info.PropertySource === 1) {
          if (this.$parent.info.topType.startsWith('Star')) {
            this.$store.commit('setPayMent', 'coin');
            this.selects.warpData = this.$store.state.payMent || 'coin';
          } else {
            let lengthNumber = this.buyList.length + this.rentList.length
            if (lengthNumber < 3) {
              this.$store.commit('setPayMent', 'free');
              this.selects.warpData = this.$store.state.payMent || 'free';
            } else {
              if (this.renewalType) {
                this.$store.commit('setPayMent', 'free');
                this.selects.warpData = this.$store.state.payMent || 'free';
              } else {
                this.$store.commit('setPayMent', 'coin');
                this.selects.warpData = this.$store.state.payMent || 'coin';
              }
            }
          }
        } else {
          this.$store.commit('setPayMent', 'coin');
          this.selects.warpData = this.$store.state.payMent || 'coin';
        }
      }
    },
    updateWay() {
      let lengthNumber = this.buyList.length + this.rentList.length
      if ((this.$parent.info.PropertyCategory == 2 || this.$parent.info.PropertyCategory == 3) && (this.$parent.mode == 'copy' || this.$route.query.type  == 2 || this.$route.query.type  == 1)) {
        this.store.commit('setPayMent', 'coin')
      } else if (this.$route.query.type  == 1) {
        this.store.commit('setPayMent', 'coin')
      }
      this.$parent.way = this.$store.state.payMent
      this.$emit('update-way', {way:this.$store.state.payMent, PropertySource: this.$parent.info.PropertySource});
    },
    estateAddressTips() {
      this.tipsShow = true;
    },
    unitFloorTips() {
      this.unitFloorTipsShow = true;
    },
    pick(data) {
      if(this.$route.query.type == 'edit'){
        this.$parent.clearBocPro();
      }
      this.selects.childData = data.dictionaryValue;
    },
    pickWhatsApp(data) {
      if (this.selects.childData.indexOf(data.dictionaryValue) > -1) {
        this.selects.childData = [];
      }
    },
    tipsEven(item) {
      if(item === '8') {
        this.tipsDialog_GongJv = true;
      } else if (item === 'free') {
        this.freeYezhuPopup = true;
      } else {
        this.tipsDialog = true;
      }
    },
    getData(data) {
      this.axios
        .post(this.pub.getApi().SearchEstateSuggester, {
          parentEstateId: data,
          order: 'PhaseSequenceAsc', // 按期数排序
          pageIndex: 1,
          pageCount: 20,
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            this.store.commit('setPhase', res.data.result.data);
            this.$parent.info.estateType = 'bigest'; 
            this.chooseData = { title: this.lang.housenum, children: res.data.result.data };
          }
        });
    },
    clearPlans() {
      this.store.state.platimg = '';
    },
    keywords() {
      this.store.commit('setRentalType', true)
      this.$router.push({ path: '/commonword', query: { id: 'title', propertyCategory: this.$parent.info['PropertyCategory'] } });
    },
    introducewords() {
      this.store.commit('setRentalType', true)
      this.$router.push({ path: '/commonword', query: { id: 'introduce', propertyCategory: this.$parent.info['PropertyCategory'] } });
    },
    facilitiesAndServicesWords() {
      this.$router.push({ path: '/facilitiesAndServices', query: { id: 'services', propertyCategory: this.$parent.info['PropertyCategory'] } });
    },
    showPriceDiff(data){
      this.showPriceTip = false
    },
    focusPrice(){
      this.showPriceTip = false
      this.$refs['elsalePrice'].focus()
    },
    /*放售价提示*/
    async sellPrice($event, data) {
      if(this.attr == 'rentPrice' || this.attr == 'paidSalePrice') this.$parent.Unit()
      if(this.attr == 'unPaidSalePrice') this.$parent.isShowReaduce('unPaidSalePrice','firstUnPaidSalePrice','isReduceUnpaid','isReduceUnPaidSalePrice')

      if (this.attr === 'propertyNo') {
        this.$parent.info[this.attr] = $event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
      }
      if (this.attr === 'paidSalePrice' || this.attr == 'unPaidSalePrice') {
        if(data == 0) this.$parent.info[this.attr] = ''
        // 车位-1kw 其余类型10亿
        if (!data) return;
        data = String(data);
        let langKey= this.url.indexOf('en-us') >-1? 0:this.url.indexOf('zh-cn') > -1 ?1:2
        const lang = [
          {'saleO':'Selling price of your listing property is','saleOt':'million',"saleOth":'Confirm','saleOse':'There is a big difference between the sale price you input and the original.','saleOe':'Please confirm if the price is correct','saleOn':'OK'},
          {'saleO':'你的楼盘放售价是','saleOt':'亿',"saleOth":'确定','saleOse':'你所输入的售价与原本的有很大的差距','saleOe':'请确认售价是否正确','saleOn':'知道了'},
          {'saleO':'你的樓盤放售價是','saleOt':'億',"saleOth":'確定','saleOse':'你所輸入的售價與原本的有很大的差距','saleOe':'請確認售價是否正確','saleOn':'知道了'},
        ]
        if(this.$parent.dialogHide && this.$parent.mode !== 'edit' && this.$parent.info.subCategory[0] != 6 && this.$parent.info.subCategory[0] != 7){
          this.showPriceTip = (this.$parent.info['PropertyCategory'] == 4 && data >= 1000) || data >= 100000 ? true : false 
        }
        if(this.$parent.dialogHide && this.$parent.mode !== 'edit' && this.attr === 'paidSalePrice' && (this.$parent.info.subCategory[0] == 6 || this.$parent.info.subCategory[0] == 7)){
          if(data && data.length >= 5){
            Dialog.alert({
              message:`${lang[langKey]['saleO']} ${this.url.indexOf('en-us') >-1?(data * 1000000) / 1000000 / 100 :Math.round((data / 10000) * 100) / 100}${lang[langKey]['saleOt']}`,
              confirmButtonText: lang[langKey]['saleOth'],
              closeOnClickOverlay: false,
            })
          }
        }
        if(this.$parent.dialogHide && this.$parent.mode == 'edit'){
          let orignprice =  this.attr == 'unPaidSalePrice' && (this.$parent.info.subCategory[0] == 6 || this.$parent.info.subCategory[0] == 7 ) ? this.orignUnpaidPrice : this.orignprice
          if(data && data.length >= 5){
            Dialog.alert({
              message:`${lang[langKey]['saleO']} ${this.url.indexOf('en-us') >-1?(data * 1000000) / 1000000 / 100 :Math.round((data / 10000) * 100) / 100}${lang[langKey]['saleOt']}`,
              confirmButtonText: lang[langKey]['saleOth'],
              closeOnClickOverlay: false,
            }).then(() => {
              if (this.$parent.mode !== 'copy' && orignprice !== 0 && (data <= orignprice - orignprice * 0.3 || data >= orignprice + orignprice * 0.3)) {
                Dialog({ title: lang[langKey]['saleOse'], message: lang[langKey]['saleOe'], confirmButtonText: lang[langKey]['saleOn'] });
              }
            })
          }else if(data){
            if (this.$parent.mode !== 'copy' && orignprice !== 0 && (data <= orignprice - orignprice * 0.3 || data >= orignprice + orignprice * 0.3)) {
                Dialog({ title: lang[langKey]['saleOse'], message: lang[langKey]['saleOe'], confirmButtonText: lang[langKey]['saleOn'] });
              }
          }
        }
        return
        if (this.url.indexOf('en-us') > -1 && data && data.length >= 5) {
          Dialog.alert({
            message: `Selling price of your listing property is ${(data * 1000000) / 1000000 / 100} million`,
            confirmButtonText: 'confrim',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
              Dialog({ title: 'There is a big difference between the sale price you input and the original.', message: ` Please confirm if the price is correct`, confirmButtonText: 'OK' });
            }
          });
        } else if (this.url.indexOf('zh-cn') > -1 && data && data.length >= 5) {
          Dialog.alert({
            message: `你的楼盘放售价是 ${Math.round((data / 10000) * 100) / 100} 亿元`,
            confirmButtonText: '确认',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
              Dialog({ title: '你所输入的售价与原本的有很大的差距', message: `请确认售价是否正确`, confirmButtonText: '知道了' });
            }
          });
        } else if (data && data.length >= 5) {
          Dialog.alert({
            message: `你的樓盤放售價是 ${Math.round((data / 10000) * 100) / 100} 億元`,
            confirmButtonText: '確認',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
              Dialog({ title: '你所輸入的售價與原本的有很大的差距', message: `請確認售價是否正確`, confirmButtonText: '知道了' });
            }
          });
        } else if (this.url.indexOf('en-us') > -1 && data) {
          if (this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
            Dialog({ title: 'There is a big difference between the sale price you input and the original', message: ` Please confirm if the price is correct`, confirmButtonText: 'OK' });
          }
        } else if (this.url.indexOf('zh-cn') > -1 && data) {
          if (this.$parent.mode !== 'copy' && this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
            Dialog({ title: '你所输入的售价与原本的有很大的差距', message: `请确认售价是否正确`, confirmButtonText: '知道了' });
          }
        } else if (data) {
          if (this.$parent.mode !== 'copy' && this.orignprice !== 0 && (data <= this.orignprice - this.orignprice * 0.3 || data >= this.orignprice + this.orignprice * 0.3)) {
            Dialog({ title: '你所輸入的售價與原本的有很大的差距', message: `請確認售價是否正確`, confirmButtonText: '知道了' });
          }
        }
      }

      if (this.attr === 'rentPrice') {
        if(data == 0) this.$parent.info[this.attr] = ''
        if (!data) return;
        data = String(data);
        // if (this.url.indexOf('en-us') > -1 && data && data.length >= 9) {
        //   Dialog({ message: `Leasing price of your listing property is ${Math.round((data / 1000000) * 100) / 100} million`, confirmButtonText: 'confrim' });
        // } else if (this.url.indexOf('zh-cn') > -1 && data && data.length >= 9) {
        //   Dialog({ message: `你的楼盘放租价是 ${Math.round((data / 100000000) * 100) / 100} 亿元`, confirmButtonText: '确认' });
        // } else if (data && data.length >= 9) {
        //   Dialog({ message: `你的樓盤放租價是 ${Math.round((data / 100000000) * 100) / 100} 億元`, confirmButtonText: '確認' });
        // }
        if (this.url.indexOf('en-us') > -1 && data && data.length >= 9) {
          Dialog.alert({
            message: `Leasing price of your listing property is ${Math.round((data / 1000000) * 100) / 100} million`,
            confirmButtonText: 'confrim',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
              Dialog({ title: `There is a big difference between the rent price you input and the original`, message: `Please confirm if the price is correct`, confirmButtonText: 'OK' });
            }
          });
        } else if (this.url.indexOf('zh-cn') > -1 && data && data.length >= 9) {
          Dialog.alert({
            message: `你的楼盘放租价是 ${Math.round((data / 100000000) * 100) / 100} 亿元`,
            confirmButtonText: '确认',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
              Dialog({ title: '你所输入的租价与原本的有很大的差距', message: `请确认租价是否正确`, confirmButtonText: '知道了' });
            }
          });
        } else if (data && data.length >= 9) {
          Dialog.alert({
            message: `你的樓盤放租價是 ${Math.round((data / 100000000) * 100) / 100} 億元`,
            confirmButtonText: '確認',
          }).then(() => {
            if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
              Dialog({ title: '你所輸入的租價與原本的有很大的差距', message: `請確認租價是否正確`, confirmButtonText: '知道了' });
            }
          });
        } else if (this.url.indexOf('en-us') > -1 && data) {
          if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
            Dialog({ title: `There is a big difference between the rent price you input and the original`, message: `Please confirm if the price is correct`, confirmButtonText: 'OK' });
          }
        } else if (this.url.indexOf('zh-cn') > -1 && data) {
          if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
            Dialog({ title: '你所输入的租价与原本的有很大的差距', message: `请确认租价是否正确`, confirmButtonText: '知道了' });
          }
        } else if (data) {
          if (this.$parent.mode !== 'copy' && this.orignrprice !== 0 && (data <= this.orignrprice - this.orignrprice * 0.3 || data >= this.orignrprice + this.orignrprice * 0.3)) {
            Dialog({ title: '你所輸入的租價與原本的有很大的差距', message: `請確認租價是否正確`, confirmButtonText: '知道了' });
          }
        }
      }
    },
    
    inputEvent($event) {
      // 物业编号只允许输入数字字母和字符
      if (this.attr === 'propertyNo') {
        this.$parent.info[this.attr] = $event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
        // 租价售价面积管理费等 只允许输入数字
      } else if (['paidSalePrice','unPaidSalePrice', 'rentPrice', 'buildingArea', 'saleableArea', 'buildingAge'].includes(this.attr)) {
        // if (this.attr === 'propertyNo') {
        //   this.$parent.info[this.attr] = $event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
        // }
        this.$parent.info[this.attr] = $event.target.value.replace(/\D/g, '');
        this.$nextTick(() => {
          this.$forceUpdate();
        });
        //判断attr是不是saleableArea
        if (this.attr == 'saleableArea') {
          // 把输入的面积存入vuex
          this.store.commit('setsaleableArea', { saleableArea: $event.target.value.replace(/\D/g, '') });
        }
        // 中英文标题介绍&设施与服务需要调用接口判断是否含敏感词
      } else if (['titleCN', 'titleEN', 'introduceCN', 'introduceEN', 'servicesCN', 'servicesCEN'].includes(this.attr)) {
        this.$parent.info[this.attr] = $event.target.value;
        this.$parent.sensitive();
      } else if (this.attr === 'estateAddress') {
        this.estateAddressValue = $event.target.value;
        this.$parent.info[this.attr] = this.estateAddressValue;
        this.$parent.info.estateAddressWithCulture = this.estateAddressValue;
        // if (this.$parent.info.estateID == 0) {
        //   this.$parent.info.estateAddressWithCulture = this.estateAddressValue;
        // }

      } else if (this.attr == 'buildingNameWithCulture') {
        this.$parent.info[this.attr] = $event.target.value;
        this.store.commit('setBuildSelectText', $event.target.value);
      } else if (this.attr == 'roomNoWithCulture') {
        this.$parent.info[this.attr] = $event.target.value;
        this.store.commit('setroomNoWithCulture', $event.target.value);
        this.store.commit('setSelectRoomNoData', { roomNo: $event.target.value, roomNoEN: '', roomNoWithCulture: $event.target.value });
        this.$emit('get-input', this.attr, $event.target.value);
      } else if (this.attr == 'telphone') {
        const inputValue = $event.target.value.slice(0, 8);
        this.$parent.userInfo[this.attr] = inputValue;
      } else if (this.attr == 'customerTel') {
        const inputValue = $event.target.value.slice(0, 11);
        this.$parent.userInfo[this.attr] = inputValue;
      } else {
        this.$parent.info[this.attr] = $event.target.value;    
      }
    },
    confirm(value) {
      this.selectText = value.toLocaleDateString();
      this.showChoose = false;
      this.$parent.info.beginRentTime = parseInt(value.getTime() / 1000);
    },
    cancel() {
      this.showChoose = false;
      this.selectText = this.lang.pleSelect;
      this.$parent.info.beginRentTime = 0
    },
    /*分类选择禁用规则*/
    cateDisable(item) {
      return (item.dictionaryValue == 6 && this.selects.childData.includes('7')) || (item.dictionaryValue == 7 && this.selects.childData.includes('6'));
    },
    /*楼盘类型分类选择禁用规则*/
    cateDisable_PropertyCategory(item) {
      const prohibitedValues = this.prohibitSelection
      if (this.selects.childData.length >= 2) {
        return !this.selects.childData.includes(item.dictionaryValue);
      } else {
        if (this.selects.childData.length > 0) {
          const selectedValue = this.selects.childData[0];
          const prohibitedList = prohibitedValues[selectedValue.toString()];
          return prohibitedList ? prohibitedList.includes(parseInt(item.dictionaryValue)) : false;
        }
      }
    },
    /*选项高度*/
    autoHeight() {
      let small = document.body.clientWidth <= 375;
      var height;
      if (this.attr == 'RoomNumber' || this.attr == 'RentLabel') {
        height = 58;
      } else if (this.attr == 'PropertySource' || this.attr == 'isShowTel' || this.attr == 'isHideCompanyInfo') {
        height = 30;
      } else if (this.attr == 'way') {
        height = 40;
      } else if (this.attr == 'roomNoWithCulture') {
        height = 60;
      } else if (this.attr == 'buildFloor') {
        height = 60;
      } else {
        height = 50;
      }
      small ? (height += 10) : height;
      return height + '%';
    },
    // 根据value解析到字典文字
    parseValue() {
      this.selectText = this.lang.pleSelect;
      if (this.selects.warpData === -2) return;
      if (this.chooseData.children) {
        this.categoryType = this.selects.warpData;
        this.chooseData.children.forEach((item) => {
          if (String(item.dictionaryValue) == String(this.selects.warpData)) {
            this.selectText = item.dictionaryNameWithCulture;
            this.selectWarp(item);
            if (this.selects.childData.length && this.chooseChild.length) {
              this.chooseChild.forEach((child, index) => {
                if (this.categoryType == '1' && this.selects.childData.includes(child.dictionaryValue)) {
                  this.selectText += ',' + child.dictionaryNameWithCulture;
                } else if (this.categoryType != '1') {
                  if (this.selects.childData.includes(child.dictionaryValue)) {
                    if (index == 0) {
                      this.selectText += '-' + child.dictionaryNameWithCulture;
                    } else {
                      this.selectText += ',' + child.dictionaryNameWithCulture;
                    }
                  }
                }
              });
            }
          }
        });
      }
    },
    async parseRent(type) {
      this.selectText = this.lang.pleSelect;   
      if (this.attr == 'RentLabel' && this.selects.warpData.length == 0) {
        this.store.commit('setRentText', this.lang.pleSelect);
        return;
      }
      await this.getRentLabel()
      if(this.selects.childData.includes('19') && type == 'propertyCategory'){
      this.state = '';
      this.arrRent.forEach((item) => {
        if (this.$parent.info['RentLabel'].includes(item.dictionaryValue)) {
          this.state += item.dictionaryNameWithCulture + ' ';
        }
        if (this.state) {
          this.store.commit('setRentText',this.state);
        } else {
          this.store.commit('setRentText',this.lang.pleSelect);
        }
        });
      }else if( type != 'propertyCategory' ){
        if (this.chooseData.children) {
          this.state = '';
          this.arrRent.forEach((item) => {
            if (this.selects.warpData.includes(item.dictionaryValue)) {
              this.state += item.dictionaryNameWithCulture + ' ';
            }
          });
          this.store.commit('setRentText',this.state);
        }
        if (this.state) {
          this.store.commit('setRentText',this.state);
        } else {
          this.store.commit('setRentText',this.lang.pleSelect);
        }
      }
    },
    getRentLabel(){
      return new Promise((suc, err) => {
        this.axios
          .get(this.pub.getApi().SearchDictionaryInfo, {
            params: {
              itemName: 'RentLabel',
            },
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.arrRent = res.data.result
            }
            suc()
          });
      })
    },
    // 点击请选择触发
    select() {
      // 修改在选择车位的时候楼层选项不显示的问题
      this.chooseData = this.$parent.dictionary[this.attr];
      // 因为在这里会给chooseData重新赋值，所以要判断如果是期数类型的时候，单独在给期数做处理
      if (this.attr === 'phaseWithCulture') {
        this.chooseData = { title: this.lang.housenum, children: this.store.state.estatePhase };
        this.estate = this.store.state.phaseData;
      }
      if (this.attr === 'buildingNameWithCulture') {
        if (Boolean(this.store.state.phaseText) && this.store.state.estateBuildNumByPhase.length > 0) {
          this.chooseData = { title: this.lang.buildNum, children: this.store.state.estateBuildNumByPhase };
        } else {
          this.chooseData = { title: this.lang.buildNum, children: this.store.state.estateBuildNum };
        }
        this.buildData = this.store.state.buildId;
      }
      if (this.attr === 'buildFloor') {
        this.chooseData = { title: this.lang.housenum, children: this.store.state.floorData.children };
        this.floorSelectData = this.store.state.selectFloorData;
      }
      if (this.attr === 'roomNoWithCulture') {
        this.chooseData = { title: this.lang.unitD, children: this.store.state.selectFloorData.roomResponses };
        this.roomNoData = this.store.state.selectRoomNoData;
      }
      if (this.attr === 'RoomNumber') {
        this.chooseData = this.$parent.dictionary[this.attr];
        this.roomNumberData = this.store.state.roomNumberData;
      }
      if (this.attr === 'ToiletNumber') {
        this.chooseData = this.$parent.dictionary[this.attr];
        this.toiletNumberData = this.store.state.toiletNumberData;
      }
      if (this.attr == 'isShowTel' || this.attr == 'isHideCompanyInfo') {      
        this.chooseData = this.$parent.lang[this.attr];
        // isShowTel特殊处理
        if (this.attr == 'isShowTel') {
          if (this.$parent.userInfo.isShowWeChat) {
            this.selects.childData.push(2);
          }
          if (this.$parent.userInfo.isShowWhatsApp) {
            this.selects.childData.push(1);
          }
        }
      }
      if (this.attr == 'unitFloor') {
        this.axios
          .get(this.pub.getApi().SearchDictionaryInfo, {
            params: {
              itemName: 'unitFloor',
            },
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.chooseData = { title: this.lang.height, children: res.data.result };
            }
          });
        this.unitFloorData = this.store.state.unitFloorData;
      }
      if (this.attr === 'estateName') {
        // this.showChoose = true;
        if (!this.$parent.info.PropertyCategory || this.$parent.info.PropertyCategory < 0) {
          return Toast(lang.PropertySelected);
        } else {
          if (this.target) {
            this.$router.push(`${this.target}?PropertyCategory=${this.$parent.info.PropertyCategory}`);
            return;
          }
        }
      }
      if (this.disabled) return;
      if (this.target) {
        this.$router.push(this.target);
        return;
      }
      if (
        ((this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0) || !this.store.state.floorText) &&
        this.attr == 'unitFloor' &&
        this.$parent.info.PropertyCategory == 1 &&
        this.store.state.estateBuildNum &&
        this.store.state.estateBuildNum.length > 0 &&
        this.store.state.floorData &&
        this.store.state.floorData.children.length > 0 &&
        this.store.state.buildId.buildingType == 1
      ) {
        this.showChoose = false;
      } else {
        this.showChoose = true;
      }
    },
    // 选择左侧数据
    selectWarp(item, type) {
      if (this.attr == 'way') {
        this.selects.warpData = item.attr;
        this.store.commit('setPayMent', item.attr)
        // this.store.commit('setPayMent', this.$store.state.payMent)
        this.$emit('get-select', this.attr, this.selects);
        return;
      }
      if (this.attr == 'PropertyCategory' && type) {

        if(this.$route.query.type == 'edit'){
          this.$parent.clearBocPro();
        }
        this.categoryType = item.dictionaryValue;
        this.selects.childData = [];
        if (item.itemName === '4' || item.itemName === '5') {
          this.$parent.info['RentLabel'] = []
        }
        // 由于异步赋值 导致warpdata没有数据 利用nexttick
        this.$nextTick(function () {
          // 每次点击时候
          this.store.commit("setTagsConfig",{propertyTags: ''})
          this.store.commit('setTagsCount', '0');
          this.store.commit('setRentalType', this.$parent.info.rentalType);
          // , mode: this.$parent.mode
          this.store.commit('setCategory', { warpData: this.selects.warpData });
          // 请求函数位置
        });
      }
      if (this.attr == 'phaseWithCulture') {
        this.estate = item;
        return;
      }
      if (this.attr == 'buildingNameWithCulture') {
        this.buildData = item;
        return;
      }
      if (this.attr == 'buildFloor') {
        // this.store.commit('setFloorSelectText', item.floorNameWithCulture);
        // this.selects.warpData = item.floorNameWithCulture;
        this.floorSelectData = item;
        return;
      }
      if (this.attr == 'unitFloor') {
        this.unitFloorData = item;
        // this.selects.warpData = item.floorNameWithCulture;
        return;
      }
      if (this.attr == 'roomNoWithCulture') {
        this.roomNoData = item;
        return;
      }
      if (this.attr == 'RoomNumber') {
        this.roomNumberData = item;
        return;
      }
      if (this.attr == 'ToiletNumber') {
        this.toiletNumberData = item;
        return;
      }
      if (this.attr == 'RentLabel') {
        /*服務式住宅和商務中心 只能二选一*/
        this.$emit('get-select', this.attr, this.selects);
        if ((this.selects.warpData.indexOf('5') > -1 && item.dictionaryValue == '6') || (this.selects.warpData.indexOf('6') > -1 && item.dictionaryValue == 5)) {
          return;
        }
        let hasValue = this.selects.warpData.indexOf(item.dictionaryValue);
        hasValue > -1 ? this.selects.warpData.splice(hasValue, 1) : this.selects.warpData.push(item.dictionaryValue);
        if (this.selects.warpData.indexOf('5') > -1 || this.selects.warpData.indexOf('6') > -1) {
          this.rentLabelDis = true;
        } else {
          this.rentLabelDis = false;
        }
        return;
      }
      this.selects.warpData = item.dictionaryValue;
      this.chooseChild = item.children || [];
    },
    // 清除所有选项
    clearSelect(type) {
        // 老数据修改时 必填数据不要求补回 需仍为老数据
      this.$parent.isOldData = this.$parent.saveOldData ? true :false
      if (this.attr == 'RentLabel') {
        this.selects.warpData = [];
        this.parseRent('RentLabel');
        this.rentLabelDis = false;
      } else if (this.attr == 'way') {
        this.selects.warpData = 'coin';
      } else if (this.attr == 'phaseWithCulture') {
        // 期数
        this.store.commit('setPhaseData', '');
        this.store.commit('setPhaseWarpData', '');
        this.store.commit('setPhaseSelectText', '');
        // 座数
        this.store.commit('setBuildSelectText', '');
        this.store.commit('setBuildSelectId', '');
        this.store.commit('setBuildNumByPhase', '');
        // 楼层
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setSelectFloorData', '');
        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.buildData = '';
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.estate = '';
        this.$parent.info.phaseWithCulture = '';
        this.$parent.info.buildingNameWithCulture = '';
        this.$parent.info.buildFloor = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.$emit('get-select', this.attr, this.selects);
      } else if (this.attr == 'buildingNameWithCulture') {
        // 座数
        this.store.commit('setBuildSelectText', '');
        this.store.commit('setBuildSelectId', '');
        // 楼层
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setSelectFloorData', '');
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.buildFloor = '';
        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.buildData = '';
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.buildingNameWithCulture = '';
        this.$parent.info.buildFloor = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.$emit('get-select', this.attr, this.selects);
      } else if (this.attr == 'buildFloor') {
        // 楼层
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setSelectFloorData', '');
        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.buildFloor = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.$emit('get-select', this.attr, this.selects);
      } else if (this.attr == 'roomNoWithCulture') {
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.$parent.info.roomNoWithCulture = '';
        this.roomNoData = '';
        this.$emit('get-select', this.attr, this.selects);
      } else if (this.attr == 'unitFloor') {
        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.unitFloorData = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.$emit('get-select', this.attr, this.selects);
      } else if (this.attr == 'RoomNumber') {
        this.store.commit('setRoomNumberText', '');
        this.store.commit('setRoomNumberData', '');
        this.roomNumberData = '';
        this.$emit('get-select', this.attr);
      } else if (this.attr == 'ToiletNumber') {
        this.store.commit('setToiletNumberText', '');
        this.store.commit('setToiletNumberData', '');
        this.toiletNumberData = '';
        this.$emit('get-select', this.attr);
      } else if (this.attr == 'estateName') {
        this.$parent.info.PropertyCategory = 0;
        this.selects.warpData = -1;
      } else if (this.attr == 'PropertyCategory') {
        this.selects.warpData = -2;
        this.$emit('get-select', this.attr, this.selects);
      } else {
        this.selects.warpData = -2;
      }
      this.selects.childData = [];
      this.chooseChild = [];
      this.selectText = this.lang.pleSelect;
      /*如果是点击弹出层处*/
      // if (type == 'clickPop') {
      //   this.confrim();
      // }
    },
    // 选择确认
    confrim() {
      // || (this.$route.query.type == 'copy' && this.selects.warpData != -1)
      if (this.attr == 'PropertyCategory') {
        this.$nextTick(() => {
          if (this.categoryType == 2 || this.categoryType == 3) {
            this.store.commit('setIsAllowType',false);
          } else {
            if (this.propertys && this.propertys.length >= 3) {
              this.store.commit('setIsAllowType', false);
              this.store.commit('setShopTypeData', false);
            } else {
              this.store.commit('setIsAllowType',true);
              this.store.commit('setShopTypeData', false);
            }
          }
        })
        if (this.store.state.categoryTypeData == this.selects.warpData) {
          this.store.commit('setCategoryType', this.selects.warpData);
          this.$parent.isOldData = false;
          // this.showChoose = false; //关闭对话框
          // this.$emit('get-select', this.attr, this.selects);
          // return;
        } else {
          this.store.commit('setCategoryType', this.selects.warpData);
          this.store.commit('setRoomNumberText', '');
          this.store.commit('setRoomNumberData', '');
          this.roomNumberData = '';
          this.store.commit('setToiletNumberText', '');
          this.store.commit('setToiletNumberData', '');
          this.toiletNumberData = '';
          // 复制或者编辑的时候切换楼盘类型，清空期数、座数、楼层、高中低、单位的数据，保留数据源
          if (!this.$route.query.type) {
            this.store.commit('setPhase', '');
            this.store.commit('setBuildNum', '');
            this.store.commit('setEstate', '');
            this.store.commit('setplatimg', '');
            this.store.commit('setEstateData', '');
            this.$parent.info.estateName = '';
            this.$parent.info.buildingAge = '';
            this.$parent.info.estateAddress = '';
            this.estateAddressValue = '';
          }
          // if (this.$route.query.type == 'copy' && this.$parent.info.PropertyCategory == 6 || this.categoryType == 6) {
          //   this.$parent.info.estateName = '';
          //   this.store.commit('setEstate', '');
          // }
          this.$parent.isOldData = false;
          // 期数
          this.store.commit('setPhaseData', '');
          this.store.commit('setPhaseWarpData', '');
          this.store.commit('setPhaseSelectText', '');
          // 座数
          this.store.commit('setBuildSelectText', '');
          this.store.commit('setBuildSelectId', '');
          this.store.commit('setBuildNumByPhase', '');
          // 楼层
          this.store.commit('setFloorSelectText', '');
          this.store.commit('setSelectFloorData', '');
          // 高中低
          this.store.commit('setUnitFloorSelctText', '');
          this.store.commit('setUnitFloorData', '');
          // 单位
          this.store.commit('setroomNoWithCulture', '');
          this.store.commit('setSelectRoomNoData', '');
          this.$parent.info.buildingNameWithCulture = '';
          this.$parent.info.buildFloor = '';
          this.$parent.info.roomNoWithCulture = '';
          this.$parent.info.phaseWithCulture = '';
          this.$parent.info.unitFloor = '';
        }
        this.parseRent('propertyCategory');
      }
      if (this.attr == 'phaseWithCulture') {
        // 座数
        this.store.commit('setBuildSelectText', '');
        this.store.commit('setBuildSelectId', '');
        this.store.commit('setBuildNumByPhase', '');
        // 楼层
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setSelectFloorData', '');
        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.buildData = '';
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.buildingNameWithCulture = '';
        this.$parent.info.buildFloor = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.store.commit('setPhaseWarpData', this.estate.phaseWithCulture);
        this.store.commit('setPhaseSelectText', this.estate.phaseWithCulture);
        // this.store.commit('setFirstSelectBuild', false);
        let buildingNameByphase = this.$store.state.estateBuildNum.filter((item) => {
          return item.estateID == this.estate.estateID;
        });
        if (buildingNameByphase.length == 0 && this.estate) {
          this.$parent.buildVisible = false;
        } else {
          this.$parent.buildVisible = true;
        }
        this.store.commit('setPhaseData', this.estate);
        this.store.commit('setBuildNumByPhase', buildingNameByphase);
        this.$parent.info.buildingAge = this.estate.buildingAge > 0 ? this.estate.buildingAge : this.store.state.estateInfo.buildingAge > 0 ? this.store.state.estateInfo.buildingAge : '';
        let estateID = this.estate.estateID;
        if (this.store.state.phaseWarpData) {
          this.$emit('estateAddressChange', estateID);
        } else {
          this.store.commit('setPhaseSelectText', '');
          if (!estateID) {
            this.$emit('estateAddressChange', this.$parent.info.parentEstateID);
          } else {
            this.$emit('estateAddressChange', this.estate.parentEstateID && this.estate.parentEstateID > 0 ? this.estate.parentEstateID : estateID);
          }
        }
      }
      if (this.attr == 'buildingNameWithCulture') {
        // 楼层
        this.store.commit('setFloorSelectText', '');
        this.store.commit('setSelectFloorData', '');

        // 高中低
        this.store.commit('setUnitFloorSelctText', '');
        this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.floorSelectData = '';
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.buildFloor = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.store.commit('setBuildSelectId', this.buildData);
        this.store.commit('setBuildSelectText', this.buildData.phaseAndBuildingNameWithCulture);
        if (Boolean(this.buildData.buildingAddressWithCulture)) {
          this.$parent.info.estateAddress = this.buildData.buildingAddressWithCulture;
        }
        // this.$parent.info.buildingAge = this.buildData.buildingAge > 0 ? this.buildData.buildingAge : '';
        if (this.store.state.buildId.buildingType == 1) {
          this.$parent.info.roomNoWithCulture = '';
          this.store.commit('setroomNoWithCulture', '');
        }
        let phaseByBuildName = this.$store.state.estatePhase.filter((item) => {
          return item.estateID == this.buildData.estateID;
        });

        if (phaseByBuildName.length > 0) {
          // this.store.commit('setFirstSelectBuild', true);
          this.store.commit('setPhaseData', phaseByBuildName[0]);
          this.store.commit('setPhaseSelectText', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseWithCulture : '');
          this.store.commit('setPhaseWarpData', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseWithCulture : '');
          this.$parent.info.phaseWithCulture = phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseWithCulture : '';
          this.$parent.info.buildingAge = phaseByBuildName[0].buildingAge > 0 ? phaseByBuildName[0].buildingAge : '';
          this.estate = phaseByBuildName[0];
        }
        this.store.commit('setBuildSelectText', this.buildData.phaseAndBuildingNameWithCulture);
        this.$parent.info.buildingNameWithCulture = this.buildData.phaseAndBuildingNameWithCulture;
      }
      if (this.attr == 'buildFloor') {
        // 高中低
        // this.store.commit('setUnitFloorSelctText', '');
        // this.store.commit('setUnitFloorData', '');
        // 单位
        this.store.commit('setroomNoWithCulture', '');
        this.store.commit('setSelectRoomNoData', '');
        this.roomNoData = '';
        this.unitFloorData = '';
        this.$parent.info.unitFloor = '';
        this.$parent.info.roomNoWithCulture = '';
        this.$parent.isOldData = false;
        this.selects.warpData = -1;
        this.store.commit('setSelectRoomNoData', '');
        if (this.floorSelectData.unitFloor > 0) {
          this.$parent.info.unitFloor = this.floorSelectData.unitFloorWithCulture;
          this.store.commit('setUnitFloorSelctText', this.floorSelectData.unitFloorWithCulture);
        }
        // this.$parent.info.unitFloor = this.store.state.UnitFloorText;
        this.store.commit('setFloorSelectText', this.floorSelectData.floorNameWithCulture);
        this.store.commit('setSelectFloorData', this.floorSelectData);
        this.$parent.info.buildFloor = this.store.state.floorText;
      }
      if (this.attr == 'roomNoWithCulture') {
        this.$parent.isOldData = false;
        this.selects.warpData = -2;
        this.store.commit('setroomNoWithCulture', this.roomNoData.roomNoWithCulture);
        this.store.commit('setSelectRoomNoData', this.roomNoData);
        this.$parent.info.roomNoWithCulture = this.store.state.roomNoWithCulture;
      }
      if (this.attr == 'RoomNumber') {
        this.store.commit('setRoomNumberText', this.roomNumberData.dictionaryNameWithCulture);
        this.store.commit('setRoomNumberData', this.roomNumberData);
        this.$parent.info.RoomNumber = this.roomNumberData.dictionaryValue;
      }
      if (this.attr == 'ToiletNumber') {
        this.store.commit('setToiletNumberText', this.toiletNumberData.dictionaryNameWithCulture);
        this.store.commit('setToiletNumberData', this.toiletNumberData);
        this.$parent.info.ToiletNumber = this.toiletNumberData.dictionaryValue;
      }
      if (this.attr == 'unitFloor') {
        this.$parent.isOldData = false;
        this.store.commit('setUnitFloorSelctText', this.unitFloorData.dictionaryNameWithCulture);
        this.store.commit('setUnitFloorData', this.unitFloorData);
        this.$parent.info.unitFloor = this.store.state.UnitFloorText;
      }
      if (this.attr == 'PropertySource') {
        this.$store.commit("setShopTypeData", false)
        if (this.$parent.mode == 'copy' && this.$parent.info.PropertySource == 1) {
          this.$store.commit("setShopTypeData", true)
        }
        if (this.$parent.way == 'free') {
          this.$store.commit("setPayMent", 'coin')
        }
      }
      if (this.attr == 'RentLabel') {
        this.parseRent('RentLabel');
      } else {
        this.parseValue();
      }
      this.showChoose = false; //关闭对话框
      if (this.attr == 'RentLabel') {
        this.$parent.getSelect(this.attr, this.selects);
      } else this.$emit('get-select', this.attr, this.selects);
    },
  },
};
</script>

<style lang="scss" scoped>
.disabledColor {
  color: #ccc !important;
}
.words {
  float: right;
}
.cell-vid {
  width: 100%;
  height: 15px;
  background-color: red;
}

.cell-pay {
  .payway {
    background-color: #fff;
    li:first-child {
      border-top: none;
    }
    h3 {
      color: #333333;
      padding: 15px;
      font-size: 15px;
      font-weight: 600;
      color: #333333;
    }
    .paycol {
      width: 23px;
    }
    .paycol /deep/.van-icon {
      border: 1px solid #979797;
      border-radius: 50%;
    }
    .unclickable {
      pointer-events: none;
    }
    .enable-click {
      pointer-events: auto;
    }
  }
  .pay-content {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    background: #fff;
    position: relative;
    // h3 {
    //   line-height: 36px;
    //   font-size: 15px;
    //   font-weight: 500;
    //   color: #333333;
    // }
    .coin {
      img {
        margin-top: 6px;
        position: relative;
        left: -15px;
      }
      span {
        font-weight: 600;
        background: linear-gradient(to right, #6f5118, #a3852f);
        -webkit-background-clip: text;
        color: transparent;
        position: relative;
        top: -8px;
        left: -8px;
      }
    }
    .paypal {
      text-align: right;
      img {
        width: 58px;
        height: 16px;
        margin-right: 20px;
      }
    }
    .trans {
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-right: 20px;
      margin-top: 6px;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 17px;
      margin-right: 20px;
      text-align: right;
    }
    .van-icon-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -10px;
    }
  }
}

.noborder {
  border-bottom: none !important;
}
.topBorder {
  border-top: 1px solid #eee;
}
.paddingTop15 {
  padding-top: 15px;
}
.paddingTop0 {
  padding-top: 0 !important;
}
.cell {
  background: #fff;
  padding: 15px 15px 0;
  .cell-tip {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #f73343;
    line-height: 17px;
  }
  .cell-head {
    .required {
      color: #ed1818;
    }
    h3 {
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      line-height: 21px;
      display: inline-block;
    }
    .vidDiv {
      height: 60px;
      line-height: 21px;
      position: relative;
      .vid-conetnt {
        font-size: 15px;
        font-weight: 400;
        color: #b2b2b2;
        line-height: 5px;
        padding: 14px 0;
      }
    }
    .vidText {
      // padding-top: 12px;
      display: block;
      height: 16px;
      line-height: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
    }
  }
  .plat-conetnt_xia {
    position: relative;
    font-size: 15px;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 21px;
    // border-bottom: 1px solid #eee;
    // padding: 10px 0;
    .divtags {
      display: inline-block;
    }
    .plat_h {
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      line-height: 21px;
      display: inline-block;
    }
    .house730 {
      font-size: 10px !important;
    }
    .platText {
      position: absolute;
      right: 33px;
      top: 8px;
    }
  }
  .plat-conetnt {
    // display: flex;
    // justify-content: space-around;
    position: relative;
    font-size: 15px;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 21px;
    border-bottom: 1px solid #eee;
    padding: 10px 0;

    .van-icon-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -10px;
    }
  }
  .tag-conetnt {
    // display: flex;
    // justify-content: space-around;
    position: relative;
    font-size: 15px;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 21px;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    .divtags {
      display: inline-block;
    }
    .tags_h {
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      line-height: 21px;
      display: inline-block;
    }
    .tagsText {
      position: absolute;
      right: 33px;
      top: 8px;
    }
    .van-icon-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -10px;
    }
  }
  .cell-conetnt {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 21px;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    img {
      margin-right: 10px;
    }
  }
  .fcolor {
    color: #666 !important;
  }
  .disableText {
    color: #ccc !important;
  }
  .disText {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
  }
  .cell-input {
    input {
      border: none;
      width: 100%;
      padding-left: 0px;
      background: #fff;
    }
    input::-webkit-input-placeholder {
      color: #b2b2b2;
    }
    .owner_name {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 20px;
    }
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
  .cell-textarea {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    textarea {
      width: 95%;
      height: 110px;
      border: none;
      padding: 0;
      resize: none;
    }
    .maxtip {
      text-align: right;
      font-size: 13px;
      color: #b2b2b2;
      line-height: 18px;
    }
  }
}
.select-most {
  position: relative;
  /deep/.van-popup {
    overflow: hidden;
  }
  .select-title {
    box-sizing: border-box;
    height: 54px;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #333333;
    // line-height: 16px;
    padding-top: 16px;
    padding-left: 16px;
  }
  .select-content {
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    color: #f73343;
    line-height: 19px;
    padding: 0 0 0 20px;
  }
  section {
    display: flex;
    .col-left,
    .col-right {
      width: 50%;
      overflow: scroll;
      max-height: 300px;
      li {
        display: flex;
        align-items: center;
        min-height: 44px;
        // line-height: 44px;
        // border-bottom: 1px solid #eee;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        padding-left: 16px;
        position: relative;
        border-bottom: 1px solid #eee;
        .line {
          width: 3px;
          height: 100%;
          background: #ed1818;
          position: absolute;
          left: 0;
          top: 0;
        }
        /deep/.van-checkbox {
          display: inline;
          position: absolute;
          right: 10px;
          width: 100%;
          height: 100%;
          padding-right: 2px;
          .van-checkbox__icon,
          .van-checkbox__label {
            float: right;
            position: relative;
            top: 15px;
          }
          .van-checkbox__label {
            float: left;
            display: block;
            position: relative;
            top: 15px;
            left: 10px;
            width: 80%;
          }
          .van-checkbox__icon {
            .van-icon {
              background-color: #fff;
            }
          }
          .van-checkbox__icon--disabled {
            .van-icon {
              border-color: #c8c9cc;
              background-color: #ebedf0;
            }
          }
          
        }
      }
      .check {
        background: #f5f6f7;
        color: #ed1818 !important;
      }
    }
    .col-right {
      height: 250px;
      overflow-y: scroll;
      li {
        background: #f5f6f7;
      }
    }
  }
  .select-bottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 76px;
    // position: fixed;
    background: #fff;
    // bottom: 0;
    // left: 0;
    width: 100%;
    line-height: 64px;
    .cancel-select {
      text-align: center;
      line-height: 44px;
      width: 164px;
      height: 44px;
      color: #999999;
      background: #eeeeee;
      border-radius: 4px;
    }
    .van-button {
      border-radius: 4px;
      width: 164px;
      margin-top: 10px;
    }
  }
}
.payway {
  section {
    padding: 0 20px;
    .downMoney {
      font-size: 12px;
      margin-top: 2px;
    }
    ul {
      width: 100%;
    }
    li {
      display: flex;
      justify-content: space-between;
      min-height: 54px;
      align-items: center;
      position: relative;
      overflow: hidden;
      border-top: 1px solid #eee;
      img {
        height: 24px;
      }
      span {
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 22px;
      }
    }
    .paypal-img {
      width: 96px;
      height: 21px;
    }
    .paypal-text {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 17px;
    }
    .cd-text {
      margin-left: 12px;
      color: #333333;
      font-size: 14px;
    }
    .coin-text {
      margin-left: 12px;
      font-weight: 600;
      background: linear-gradient(to right, #6f5118, #a3852f);
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
.disFlex {
  display: flex;
  align-items: center;
  flex: 1;
}
.confrimWidth {
  width: 90% !important;
}
.editDialog{
  padding:44px 24px 24px 24px;
  width:75%;
  .editPrice{
    margin-bottom:44px;
  }
  .editPriceText{
    color:#333333;
    font-size: 16px;
    line-height:24px;
  }
  .editBut{
    background-color: #DDDDDD;
    margin-right:25px;
  }
  .editbutsize{
    width:45%;
    border-radius:4px;
  }
  /deep/.van-dialog__footer{
    display:none
  }
}
.tipsDialog {
  width: 290px;
  padding: 24px 24px 0 24px;
  .tipsKeyWord {
    padding-bottom: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 28px;
  }
  .free_tipsKeyWord {
    padding-bottom: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 24px;
  }
}
.ali-text {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  display: flex;
  .freeTitle {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .freeOpacity {
    opacity: 0.5;
  }
  .freeMax {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #ED1C24;
    letter-spacing: 0;
  }
}
.freeOpacity {
    opacity: 0.5;
  }
.ali-tips {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333;
  margin-top: 2px;
  span {
    font-size: 12px !important;
  }
}
.ali-tips-buy {
  color: #ed1c24 !important;
}

.ali-tips-rent {
  color: #30b631 !important;
}
.paypal-image {
  width: 22px;
  height: 17px !important;
}
.trans-image {
  width: 22px;
  height: 22px !important;
}
.icon-image {
  width: 24px;
  height: 24px !important;
}
.House730 {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #f73343;
}
.unfcolor {
  color: #b2b2b2 !important;
}
.cell .unSelectColor {
  color: #b2b2b2 !important;
}
.estateAddress-box {
  display: flex;
  align-items: center;
}
.displayFlex {
  display: flex;
  align-items: center;
}
</style>
